import Vue from "vue";

export async function indexar(params) {
  const response = await Vue.prototype.$http.get(`/movimentacoes-ficha`, {
    params
  });

  return response.data;
}
